module.exports = __webpack_public_path__ + "static/media/Eric Wright.71648b04.png";